import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { BulkApprovalPage } from './BulkApprovalPage';
import { PlanDaysPage } from './PlanDaysPage';
import { VesselDetailPage } from './VesselDetailPage';
import { VesselFormPage } from './VesselFormPage';
import { VesselListPage } from './VesselListPage';

/**
 * 参加船名簿（S-10〜S-13）。パスは `/years/:year` からの相対。
 * 一覧・詳細は全ロール（庁・県は参照のみ。メニューには出さないが API では参照可）。
 */
export const routes: RouteObject[] = [
  {
    path: 'vessels',
    handle: { crumb: '参加船名簿' } satisfies RouteHandle,
    element: <Outlet />,
    children: [
      { index: true, element: <VesselListPage /> },
      { path: 'new', element: <VesselFormPage />, handle: { crumb: '新規登録' } satisfies RouteHandle },
      {
        path: 'bulk-approval',
        element: (
          <RequireAuth roles={['基金']}>
            <BulkApprovalPage />
          </RequireAuth>
        ),
        handle: { crumb: '一括承認' } satisfies RouteHandle,
      },
      {
        path: 'plan-days',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <PlanDaysPage />
          </RequireAuth>
        ),
        handle: { crumb: '計画日数登録' } satisfies RouteHandle,
      },
      { path: ':id', element: <VesselDetailPage />, handle: { crumb: '詳細' } satisfies RouteHandle },
      { path: ':id/edit', element: <VesselFormPage />, handle: { crumb: '編集' } satisfies RouteHandle },
    ],
  },
];
